import axios from 'axios';
import { Ability } from '@casl/ability';
import store from './index';

export default {
  namespaced: true,

  state: {
    abilities: [],
    permissions: []
  },

  getters: {
    getAbilities() {
      return new Ability();
    },
    getPermissions(state) {
      return state.permissions;
    }
  },

  mutations: {
    SET_ABILITIES(state, value) {
      state.abilities = value;

      //console.log(store.getters['abilities/getAbilities']);

      const ability = store.getters['abilities/getAbilities'];
      ability.update([{ action: state.abilities, subject: 'all' }]);
    },
    SET_PERMISSIONS(state, value) {
      state.permissions = value;
    }
  },

  actions: {
    update({ commit }) {
      axios
        .get('/api/abilities')
        .then(res => {
          commit('SET_ABILITIES', res.data.data);
        })
        .catch(err => {
          commit('SET_ABILITIES', []);
        });
    },
    getAllPermissions({ commit }) {
      axios.get('/api/permissions').then(res => {
        const permissions = res.data.data;
        commit('SET_PERMISSIONS', permissions);
      });
    }
  }
};
